module.exports = __webpack_public_path__ + "static/media/check.a11c184e.svg";